import React from 'react'
import Sidebar from '../../../Sidebar'
import Navbar from '../../../Navbar'

const DisputeOpen = () => {
  return (
    <>
      <Sidebar/>
        <div className="main">
          <div className="topbar">
            <Navbar title="Dispute Open"/>
          </div>
        </div>
    </>
  )
}

export default DisputeOpen
